import { name } from "../../package.json.js";
const APP = {
  name
};
export {
  APP
};
